import { type RefObject, useEffect } from 'react';

export function useCallbackWhenIntersected(ref: RefObject<HTMLElement | null>, callback?: () => any) {
  useEffect(() => {
    if (typeof window === 'undefined' || !ref.current) return;

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        callback?.();
        observer.disconnect();
      }
    });

    observer.observe(ref.current);

    return () => {
      observer.disconnect();
    };
  }, [ref, callback]);
}
